import React from "react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const Blockers = ({ stories }) => {
  // Stories with status BLOCKED or isBlocked flag
  const blockers = stories.filter(
    (s) => s.status === "BLOCKED" || s.isBlocked === true || s.blocked === true
  ).slice(0, 5);

  return (
    <div style={{
      background:"#fff", borderRadius:12, border:"1px solid #e5e7eb",
      boxShadow:"0 1px 4px rgba(0,0,0,.06)", padding:"16px 18px", height:"100%"
    }}>
      {/* Header */}
      <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:12 }}>
        <WarningAmberIcon sx={{ fontSize:16, color:"#f59e0b" }} />
        <span style={{ fontSize:13, fontWeight:700, color:"#111827" }}>Blockers</span>
        <span style={{ fontSize:11, color:"#9ca3af" }}>
          {blockers.length} blocked {blockers.length === 1 ? "task" : "tasks"}
        </span>
      </div>

      {/* List */}
      {blockers.length === 0 ? (
        <p style={{ fontSize:12, color:"#6b7280", margin:0 }}>
          No blockers — great work! 🎉
        </p>
      ) : (
        blockers.map((b, i) => (
          <div key={b.id || i} style={{
            display:"flex", alignItems:"flex-start", gap:8, padding:"7px 0",
            borderBottom: i < blockers.length - 1 ? "1px solid #f3f4f6" : "none"
          }}>
            <span style={{
              fontSize:10, fontWeight:700, color:"#ef4444", background:"#fee2e2",
              borderRadius:4, padding:"2px 6px", whiteSpace:"nowrap", marginTop:1, flexShrink:0
            }}>
              BLK-{String(i + 1).padStart(2, "0")}
            </span>
            <div>
              <div style={{ fontSize:12, fontWeight:500, color:"#111827", lineHeight:1.4 }}>
                {b.storyName || b.title || b.name || "Unnamed story"}
              </div>
              <div style={{ fontSize:11, color:"#9ca3af" }}>
                {b.assignee?.firstName
                  ? `${b.assignee.firstName} ${b.assignee.lastName || ""}`.trim()
                  : "Unassigned"}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default Blockers;
